// ── api.js ────────────────────────────────────────────────────────────────
// Data layer. All auth is handled by auth.js.
// This file only knows about data shapes, not passwords or tokens.

import { apiFetch } from "./auth";

export async function loadAllData() {
  const data = await apiFetch("/data");
  return {
    entries:     data.entries    || {},
    bankLog:     data.bankLog    || [],
    milagePaid:  data.milagePaid || {},
    annualMiles: parseFloat(data.meta?.annualMiles) || 0,
  };
}

export async function saveKey(key, value) {
  await apiFetch("/data", {
    method: "POST",
    body: { key, value },
  });
}

export async function resetAllDataApi(initialBankLog) {
  await apiFetch("/reset", {
    method: "POST",
    body: { initialBankLog },
  });
}

export async function downloadBackup() {
  return apiFetch("/backup");
}

export async function restoreBackup(backup) {
  await apiFetch("/restore", {
    method: "POST",
    body: backup,
  });
}
